/* ============
 * Dashboard
 * ============
 *
 * This is the dashboard page.
 */

import { mapGetters, mapMutations } from 'vuex';
import Forms from '../../utils/forms/forms';
import warehouseService from '../../services/warehouse';
import orderService from './../../services/order';
import organizationSettingsService from './../../services/organizationSettings';
import store from './../../store';

export default {
  data() {
    return {
      form: new Forms({
        warehouseId: {
          type: 'select',
          value: '',
        },
      }),
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      warehouses: 'allWarehouses',
      account: 'account',
      currentOrder: 'currentOrder',
      currentEdiOrder: 'currentEdiOrder',
      settings: 'organizationSettings',
    }),
    isZNB() {
      return this.currentEdiOrder && this.currentEdiOrder.ediOrderTypeName === 'ZNB';
    },
  },

  mounted() {
    this.loading = true;
    Promise.all([
      warehouseService.all(),
      organizationSettingsService.show(),
    ]).then(() => {
      this.loading = false;
      if (this.currentOrder.warehouse.isActive === true) {
        this.form.warehouseId = this.currentOrder.warehouseId || this.settings.defaultWarehouse;
      }
    });
  },

  watch: {
    warehouses(warehouses) {
      const result = warehouses.items.filter(obj => obj.isActive === true);
      let hasModule = false;
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name == 'Inventory') {
            hasModule = true;
            this.form.setOptions('warehouseId', result);
          }
        }
      }

      if (!hasModule) {
        this.form.hideField('warehouseId');
      }
    },
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
    }),

    store() {
      this.loading = false;
      this.form.loading = true;
      const data = Object.assign({}, this.currentOrder, {
        warehouseId: this.form.warehouseId,
      });
      return orderService
        .update(store.state.route.params.id, data)
        .then(() => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: this.$t('static.ediOrders.edit.warehouseChanged'),
            customClass: 'success',
          });
          if (this.isZNB) {
            this.setModalContent(() => require('./../../components/ediOrderConfirm/ediOrderConfirm.vue'));
          } else {
            this.closeModal();
          }
        })
        .catch((errors) => {
          this.loading = false;
          this.form.loading = false;
          let message = errors.data.message;
          if (errors.data.confirm_date) {
            message = errors.data.confirm_date[0];
          }

          this.$message({
            showClose: true,
            message,
            customClass: 'error',
          });
        });
    },

    /**
     * Activates the modal
     */
    activateModalEdi() {
      this.setModalClass('order-confirm');
      this.setModalContent(() => require('./../../components/ediOrderConfirm/ediOrderConfirm.vue'));
      this.setModalCloseOnClick(false);
      this.setModalShowClose(true);
      this.setModalCloseOnPressEscape(false);
    },
    /*
     * Closes the modal
     */
    closeModal() {
      if (this.currentOrder.warehouseId) {
        this.toggle(false);
        this.unsetModalContent();
      } else {
        this.$router.push({
          name: 'orders.index',
        });
        this.toggle(false);
        this.unsetModalContent();
      }
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/orderWarehousePopup/orderWarehousePopup.js